<template>
    <div class="logo">
        <img :src="theme_logo" alt="">
        <h2 v-if="showName" class="name h5">{{ helpers.tenant.name( active_tenant ) }}</h2>
    </div>
</template>

<script>
import helpers from "@/mixins/helpers";

export default {
    name: "Logo",
    props: ['showName'],
    mixins: [helpers],
}
</script>

<style lang="scss" scoped>
.name{
    margin-top: 0.6rem;
}
</style>
